!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : (e = e || self).parseCssColor = n();
}(this, function () {
  "use strict";

  var e = {
      aliceblue: [240, 248, 255],
      antiquewhite: [250, 235, 215],
      aqua: [0, 255, 255],
      aquamarine: [127, 255, 212],
      azure: [240, 255, 255],
      beige: [245, 245, 220],
      bisque: [255, 228, 196],
      black: [0, 0, 0],
      blanchedalmond: [255, 235, 205],
      blue: [0, 0, 255],
      blueviolet: [138, 43, 226],
      brown: [165, 42, 42],
      burlywood: [222, 184, 135],
      cadetblue: [95, 158, 160],
      chartreuse: [127, 255, 0],
      chocolate: [210, 105, 30],
      coral: [255, 127, 80],
      cornflowerblue: [100, 149, 237],
      cornsilk: [255, 248, 220],
      crimson: [220, 20, 60],
      cyan: [0, 255, 255],
      darkblue: [0, 0, 139],
      darkcyan: [0, 139, 139],
      darkgoldenrod: [184, 134, 11],
      darkgray: [169, 169, 169],
      darkgreen: [0, 100, 0],
      darkgrey: [169, 169, 169],
      darkkhaki: [189, 183, 107],
      darkmagenta: [139, 0, 139],
      darkolivegreen: [85, 107, 47],
      darkorange: [255, 140, 0],
      darkorchid: [153, 50, 204],
      darkred: [139, 0, 0],
      darksalmon: [233, 150, 122],
      darkseagreen: [143, 188, 143],
      darkslateblue: [72, 61, 139],
      darkslategray: [47, 79, 79],
      darkslategrey: [47, 79, 79],
      darkturquoise: [0, 206, 209],
      darkviolet: [148, 0, 211],
      deeppink: [255, 20, 147],
      deepskyblue: [0, 191, 255],
      dimgray: [105, 105, 105],
      dimgrey: [105, 105, 105],
      dodgerblue: [30, 144, 255],
      firebrick: [178, 34, 34],
      floralwhite: [255, 250, 240],
      forestgreen: [34, 139, 34],
      fuchsia: [255, 0, 255],
      gainsboro: [220, 220, 220],
      ghostwhite: [248, 248, 255],
      gold: [255, 215, 0],
      goldenrod: [218, 165, 32],
      gray: [128, 128, 128],
      green: [0, 128, 0],
      greenyellow: [173, 255, 47],
      grey: [128, 128, 128],
      honeydew: [240, 255, 240],
      hotpink: [255, 105, 180],
      indianred: [205, 92, 92],
      indigo: [75, 0, 130],
      ivory: [255, 255, 240],
      khaki: [240, 230, 140],
      lavender: [230, 230, 250],
      lavenderblush: [255, 240, 245],
      lawngreen: [124, 252, 0],
      lemonchiffon: [255, 250, 205],
      lightblue: [173, 216, 230],
      lightcoral: [240, 128, 128],
      lightcyan: [224, 255, 255],
      lightgoldenrodyellow: [250, 250, 210],
      lightgray: [211, 211, 211],
      lightgreen: [144, 238, 144],
      lightgrey: [211, 211, 211],
      lightpink: [255, 182, 193],
      lightsalmon: [255, 160, 122],
      lightseagreen: [32, 178, 170],
      lightskyblue: [135, 206, 250],
      lightslategray: [119, 136, 153],
      lightslategrey: [119, 136, 153],
      lightsteelblue: [176, 196, 222],
      lightyellow: [255, 255, 224],
      lime: [0, 255, 0],
      limegreen: [50, 205, 50],
      linen: [250, 240, 230],
      magenta: [255, 0, 255],
      maroon: [128, 0, 0],
      mediumaquamarine: [102, 205, 170],
      mediumblue: [0, 0, 205],
      mediumorchid: [186, 85, 211],
      mediumpurple: [147, 112, 219],
      mediumseagreen: [60, 179, 113],
      mediumslateblue: [123, 104, 238],
      mediumspringgreen: [0, 250, 154],
      mediumturquoise: [72, 209, 204],
      mediumvioletred: [199, 21, 133],
      midnightblue: [25, 25, 112],
      mintcream: [245, 255, 250],
      mistyrose: [255, 228, 225],
      moccasin: [255, 228, 181],
      navajowhite: [255, 222, 173],
      navy: [0, 0, 128],
      oldlace: [253, 245, 230],
      olive: [128, 128, 0],
      olivedrab: [107, 142, 35],
      orange: [255, 165, 0],
      orangered: [255, 69, 0],
      orchid: [218, 112, 214],
      palegoldenrod: [238, 232, 170],
      palegreen: [152, 251, 152],
      paleturquoise: [175, 238, 238],
      palevioletred: [219, 112, 147],
      papayawhip: [255, 239, 213],
      peachpuff: [255, 218, 185],
      peru: [205, 133, 63],
      pink: [255, 192, 203],
      plum: [221, 160, 221],
      powderblue: [176, 224, 230],
      purple: [128, 0, 128],
      rebeccapurple: [102, 51, 153],
      red: [255, 0, 0],
      rosybrown: [188, 143, 143],
      royalblue: [65, 105, 225],
      saddlebrown: [139, 69, 19],
      salmon: [250, 128, 114],
      sandybrown: [244, 164, 96],
      seagreen: [46, 139, 87],
      seashell: [255, 245, 238],
      sienna: [160, 82, 45],
      silver: [192, 192, 192],
      skyblue: [135, 206, 235],
      slateblue: [106, 90, 205],
      slategray: [112, 128, 144],
      slategrey: [112, 128, 144],
      snow: [255, 250, 250],
      springgreen: [0, 255, 127],
      steelblue: [70, 130, 180],
      tan: [210, 180, 140],
      teal: [0, 128, 128],
      thistle: [216, 191, 216],
      tomato: [255, 99, 71],
      turquoise: [64, 224, 208],
      violet: [238, 130, 238],
      wheat: [245, 222, 179],
      white: [255, 255, 255],
      whitesmoke: [245, 245, 245],
      yellow: [255, 255, 0],
      yellowgreen: [154, 205, 50]
    },
    n = new RegExp(/^#([a-f0-9]{3,4}|[a-f0-9]{4}(?:[a-f0-9]{2}){1,2})\b$/, "i"),
    r = "-?\\d*(?:\\.\\d+)",
    a = "(" + r + "?)",
    l = "(" + r + "?%)",
    t = ("^\n  hsla?\\(\n    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*,\n    \\s*" + l + "\\s*,\n    \\s*" + l + "\\s*\n    (?:,\\s*(-?\\d*(?:\\.\\d+)?%?)\\s*)?\n  \\)\n  $\n").replace(/\n|\s/g, ""),
    s = new RegExp(t),
    i = ("^\n  hsla?\\(\n    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*\n    \\s+" + l + "\n    \\s+" + l + "\n    \\s*(?:\\s*\\/\\s*(-?\\d*(?:\\.\\d+)?%?)\\s*)?\n  \\)\n  $\n").replace(/\n|\s/g, ""),
    o = new RegExp(i),
    d = ("^\n  rgba?\\(\n    \\s*" + a + "\\s*,\n    \\s*" + a + "\\s*,\n    \\s*" + a + "\\s*\n    (?:,\\s*(-?\\d*(?:\\.\\d+)?%?)\\s*)?\n  \\)\n  $\n").replace(/\n|\s/g, ""),
    u = new RegExp(d),
    g = ("^\n  rgba?\\(\n    \\s*" + l + "\\s*,\n    \\s*" + l + "\\s*,\n    \\s*" + l + "\\s*\n    (?:,\\s*(-?\\d*(?:\\.\\d+)?%?)\\s*)?\n  \\)\n  $\n").replace(/\n|\s/g, ""),
    p = new RegExp(g),
    c = ("^\n  rgba?\\(\n    \\s*" + a + "\n    \\s+" + a + "\n    \\s+" + a + "\n    \\s*(?:\\s*\\/\\s*(-?\\d*(?:\\.\\d+)?%?)\\s*)?\n  \\)\n$\n").replace(/\n|\s/g, ""),
    h = new RegExp(c),
    m = ("^\n  rgba?\\(\n    \\s*" + l + "\n    \\s+" + l + "\n    \\s+" + l + "\n    \\s*(?:\\s*\\/\\s*(-?\\d*(?:\\.\\d+)?%?)\\s*)?\n  \\)\n$\n").replace(/\n|\s/g, ""),
    f = new RegExp(m),
    y = new RegExp(/^transparent$/, "i"),
    b = new RegExp("[^#a-f\\d]", "gi"),
    w = new RegExp("^#?[a-f\\d]{3}[a-f\\d]?$|^#?[a-f\\d]{6}([a-f\\d]{2})?$", "i"),
    k = function (e, n, r) {
      return Math.min(Math.max(n, e), r);
    },
    v = function (e) {
      var n = e;
      return "number" != typeof n && (n = n.endsWith("%") ? 255 * parseFloat(n) / 100 : parseFloat(n)), k(Math.round(n), 0, 255);
    },
    x = function (e) {
      return k(parseFloat(e), 0, 100);
    };
  function E(e) {
    var n = e;
    return "number" != typeof n && (n = n.endsWith("%") ? parseFloat(n) / 100 : parseFloat(n)), k(n, 0, 1);
  }
  function R(e) {
    var n = function (e, n) {
      if (void 0 === n && (n = {}), "string" != typeof e || b.test(e) || !w.test(e)) throw new TypeError("Expected a valid hex string");
      var r = 1;
      8 === (e = e.replace(/^#/, "")).length && (r = parseInt(e.slice(6, 8), 16) / 255, e = e.slice(0, 6)), 4 === e.length && (r = parseInt(e.slice(3, 4).repeat(2), 16) / 255, e = e.slice(0, 3)), 3 === e.length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]);
      var a = parseInt(e, 16),
        l = a >> 16,
        t = a >> 8 & 255,
        s = 255 & a;
      return "array" === n.format ? [l, t, s, r] : {
        red: l,
        green: t,
        blue: s,
        alpha: r
      };
    }(e, {
      format: "array"
    });
    return $([null, n[0], n[1], n[2], n[3]]);
  }
  function $(e) {
    var n = e[1],
      r = e[2],
      a = e[3],
      l = e[4];
    return void 0 === l && (l = 1), {
      type: "rgb",
      values: [n, r, a].map(v),
      alpha: E(null === l ? 1 : l)
    };
  }
  /**
  	 * parse-css-color
  	 * @version v0.1.2
  	 * @link http://github.com/noeldelgado/parse-css-color/
  	 * @license MIT
  	 */
  return function (r) {
    if ("string" != typeof r) return null;
    var a = n.exec(r);
    if (a) return R(a[0]);
    var l = o.exec(r) || s.exec(r);
    if (l) return function (e) {
      var n = e[1],
        r = e[2],
        a = e[3],
        l = e[4];
      void 0 === l && (l = 1);
      var t = n;
      return {
        type: "hsl",
        values: [t = t.endsWith("turn") ? 360 * parseFloat(t) / 1 : t.endsWith("rad") ? Math.round(180 * parseFloat(t) / Math.PI) : parseFloat(t), x(r), x(a)],
        alpha: E(null === l ? 1 : l)
      };
    }(l);
    var t = h.exec(r) || f.exec(r) || u.exec(r) || p.exec(r);
    if (t) return $(t);
    if (y.exec(r)) return $([null, 0, 0, 0, 0]);
    var i = e[r.toLowerCase()];
    return i ? $([null, i[0], i[1], i[2], 1]) : null;
  };
});